import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { ModuleInput, TerraformWorkflowTool } from "types/generated";

import ModuleVersionInstructionsDrawerContent from "./Content";

type ModuleVersionInstructionsDrawerProps = {
  inputs: ModuleInput[] | undefined;
  moduleName: string;
  type: string;
  submodulePath?: string;
  versionNumber: string;
  moduleSource: string;
  workflowTool: TerraformWorkflowTool;
};

const ModuleVersionInstructionsDrawer = createDrawer(
  ({
    inputs,
    moduleName,
    submodulePath,
    type,
    versionNumber,
    moduleSource,
    workflowTool,
  }: ModuleVersionInstructionsDrawerProps) => {
    return (
      <DrawerSimple variant="wide">
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Instructions" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          <ModuleVersionInstructionsDrawerContent
            inputs={inputs}
            moduleName={moduleName}
            type={type}
            versionNumber={versionNumber}
            moduleSource={moduleSource}
            workflowTool={workflowTool}
            submodulePath={submodulePath}
          />
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showModuleVersionInstructionsDrawer = createDrawerTrigger(
  ModuleVersionInstructionsDrawer
);
